import React, { useEffect, useState } from 'react';

import type { EmojiProvider } from '@atlaskit/emoji';
import { EmojiResource } from '@atlaskit/emoji/resource';

import { AudioContainer, DraggableAudio, useAudioPlayerStore } from '@atlassian/ai-audio';

import { getEmojiProvider } from '@confluence/fabric-providers/entry-points/EmojiProvider.ts';
import { type WithFlagsProps, withFlags } from '@confluence/flags/entry-points/withFlags.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { audioFeatures } from '../../../entry-points/audioFeatures.ts';

type AudioContainerWrapperProps = {} & WithFlagsProps;

export const FloatingAudioContainer = withFlags(({ flags }: AudioContainerWrapperProps) => {
	const { isOpen } = useAudioPlayerStore();
	const { activationId, userId, cloudId } = useSessionData();
	const [emojiProvider, setEmojiProvider] = useState<EmojiProvider | undefined>(undefined);

	useEffect(() => {
		//getEmojiProvider returns a promise, but getEmojiProvider requires it to be resolved. This middle step ensures the promise has returned before the value is passed
		getEmojiProvider(EmojiResource, { cloudId, userId })
			.then(setEmojiProvider)
			.catch(() => {});
	}, [cloudId, userId]);

	return isOpen && emojiProvider ? (
		<DraggableAudio>
			{({ isDragging }) => (
				<AudioContainer
					product="confluence"
					cloudId={cloudId}
					activationId={activationId}
					emojiProvider={emojiProvider}
					audioFeatures={audioFeatures}
					flags={flags}
					pinToExpandedView={isDragging}
				/>
			)}
		</DraggableAudio>
	) : null;
});
